export default __webpack_public_path__ + "static/media/GSTR-1.c098db22.jpg";